import { FunctionComponent } from 'react';
import styles from "./CatchRatePerformanceCard.module.css";
import skeletonStyles from "./CatchRatePerformanceCardSkeleton.module.css";
import cn from 'classnames';

interface ICatchRatePerformanceCardSkeletonProps {
    className?: string;
};

const CatchRatePerformanceCardSkeleton: FunctionComponent<ICatchRatePerformanceCardSkeletonProps> = () => {
    
    return (
        <div className={cn(styles.catchRatePerformanceCard)}>
            <div className={styles.header}>
                <div className={cn(styles.cardTitle, skeletonStyles.skeletonTitle, 'shimmer-bg')}></div>
                <div className={cn(styles.cardSummary, skeletonStyles.skeletonSummary, 'shimmer-bg')}></div>
            </div>
            <div className={styles.body}>
                <div className={cn(skeletonStyles.skeletonProgressBar, 'shimmer-bg')}>
                </div>
            </div>
            <div className={styles.footer}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <div key={index} className={cn(styles.footerCard, skeletonStyles.skeletonFooterCard)}>
                        <div className={cn(styles.footerCardTitle, skeletonStyles.skeletonFooterTitle, 'shimmer-bg')}></div>
                        <div className={cn(styles.footerCardSummary, skeletonStyles.skeletonFooterSummary, 'shimmer-bg')}></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CatchRatePerformanceCardSkeleton;